const HTTP = 'http://';
const HTTPS = 'https://';
const MAILTO = 'mailto:';
const TEL = 'tel:';
const RELATION = 'noopener nofollow';
export { HTTP, HTTPS, MAILTO, TEL, RELATION };
//# sourceMappingURL=constants.js.map